// Go-live readiness pill — the state is the server's (GET /readiness,
// /me/readiness); this only maps it to copy and colour.
import { useT } from '../lib/i18n';
import React from 'react';
import type { ReadinessState } from '@/services/learningService';

const CLS: Record<ReadinessState, string> = {
  ready: 'bg-success-soft text-success-strong',
  at_risk: 'bg-amber-100 text-amber-700 dark:bg-amber-500/[0.16] dark:text-amber-300',
  not_ready: 'bg-red-100 text-red-700 dark:bg-red-500/[0.16] dark:text-red-300',
};

export const readinessLabel = (t: (k: string, d: string) => string, state: ReadinessState | string): string => ({
  ready: t('training:readiness_ready', 'Go-live ready'),
  at_risk: t('training:readiness_at_risk', 'At risk'),
  not_ready: t('training:readiness_not_ready', 'Not ready'),
}[state as ReadinessState] || String(state).replace('_', ' '));

export const ReadinessBadge: React.FC<{ state: ReadinessState | string; className?: string; size?: 'sm' | 'md' }> = ({ state, className, size = 'sm' }) => {
  const t = useT();
  return (
    <span data-testid="readiness-badge" data-state={state}
      className={`inline-flex items-center rounded-full font-semibold ${size === 'md' ? 'px-2.5 py-1 text-xs' : 'px-2 py-0.5 text-[10px] uppercase tracking-wide'} ${CLS[state as ReadinessState] || 'bg-muted text-muted-foreground'} ${className || ''}`}>
      {readinessLabel(t, state)}
    </span>
  );
};

export default ReadinessBadge;
